import logo from "../assets/images/Logo.svg"
import whatsAppFooter from "../assets/images/whatsAppFooter.png"
import footerLocation from "../assets/images/footerLocation.svg"
import FooterPhone from "../assets/images/FooterPhone.svg"
import footerMail from "../assets/images/footerMail.svg"
import footerInsta from "../assets/images/footerInsta.svg"
import footerTweet from "../assets/images/footerTweet.svg"
import footerLinkedin from "../assets/images/footerLinkedin.svg"
import footerFb from "../assets/images/footerFb.svg"
import bbb from "../assets/images/bbb.png"
import { Link } from "react-router-dom"

export function Footer(params) {
    return(
        <footer>
        <div className="container">
            <div className="row">
                <div className="col-lg-3 col-sm-6">
                <div className="profile">
                    <div className="imgDiv">
                    <img src={logo} alt="" />
                    </div>
                    <div className="socialDiv">
                        <a href="http://" target="_blank" rel="noopener noreferrer">
                            <img src={footerInsta} alt="" />
                        </a>
                        <a href="http://" target="_blank" rel="noopener noreferrer">
                            <img src={footerTweet} alt="" />
                        </a>
                        <a href="http://" target="_blank" rel="noopener noreferrer">
                            <img src={footerLinkedin} alt="" />
                        </a>
                        <a href="http://" target="_blank" rel="noopener noreferrer">
                            <img src={footerFb} alt="" />
                        </a>
                    </div>
                </div>
                </div>
                <div className="col-lg-3 col-sm-6">
                <div className="linkDiv">
                    <h6>Quick Links</h6>
                    <div className="footerLink">
                    <ul>
                        <li><Link to="/" >Home</Link></li>
                        <li><a href="/" >Commercial</a></li>
                        <li><a href="/" >Residential</a></li>
                        <li><a href="/" >Projects</a></li>
                        <li><Link to="/about" >About Us</Link></li>
                        <li><Link to="/safety" >Safety</Link></li>
                        <li><Link to="/faq" >FAQ</Link></li>
                    
                    </ul>
                    </div>
                </div>
                </div>
                <div className="col-lg-3 col-sm-6">
                <div className="contactDiv">
                    <h6>Contact</h6>
                    <div className="footerLink">
                    <p className="py-2 d-flex ai-fs"><img className="me-2" src={footerLocation} alt="" /> <span> 120 Banks Street. Winthrop, MA 02152 </span></p>
                    <p className="py-2"><a href="tel:6175611333" className="d-flex ai-fs word-break"><img className="me-2" src={FooterPhone} alt="" /> <span> (617) 561-1333</span> </a></p>
                    <p className="py-2"><a href="mailTo:contact@lumenspaandlaser.com" className="d-flex ai-fs word-break"><img className="me-2" src={footerMail} alt="" /> <span> contact@corollaroofing.com</span> </a></p>
                    </div>
                </div>
                </div>
                <div className="col-lg-3 col-sm-6">
                <div className="bbbDiv ">
                    <img className="img-fluid" src={bbb} alt="bbb" />
                </div>
                </div>
            </div>
        </div>
        <a className="whatsapp" href="tel:978-955-0086"><img src={whatsAppFooter} alt="" /></a>
        <div className="rightreserve">
            <p>© 2022 - Corolla Roofing. All Rights Reserved.</p>
            <p>Designed by Inoverus</p>
        </div>
    </footer>
    )
}